import { render, staticRenderFns } from "./MasterArticleDataSourcesTable.vue?vue&type=template&id=2fa89d1c&"
import script from "./MasterArticleDataSourcesTable.vue?vue&type=script&lang=js&"
export * from "./MasterArticleDataSourcesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports